var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}]},[_c('div',{attrs:{"id":"vegaView"}}),_vm._v(" "),_c('div',{staticClass:"vg-tooltip",attrs:{"id":"tip-vega","hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }